export default __webpack_public_path__ + "static/media/1.8a75bd6d.png";